// import ability from './ability'

export const canNavigate = (to, ability) => to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))

export const _ = undefined
